import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { useGetMyPermissionsQuery } from "store/apis/roles";
import { useGetUserProfileQuery } from "store/apis/profile";

export const useMyPermissions = () => {
  const { uuid: contextGroupId } = useCurrentGroupContext();
  const { isCustomer, isCpa } = useRoleBasedView();
  const { data: profile } = useGetUserProfileQuery();

  const groupId = contextGroupId || profile?.company_group;

  const { data, isLoading: queryLoading } = useGetMyPermissionsQuery(
    { groupId: groupId! },
    { skip: !groupId || !isCustomer }
  );
  const isLoading = queryLoading || (isCustomer && !groupId);

  const isSuperAdmin = Boolean(data?.is_super_admin);
  const role = data?.role ?? null;
  const permissions = data?.permissions ?? [];

  const hasPermission = (key: string, level?: "FULL" | "READ_ONLY") => {
    const perm = permissions.find((p) => p.permission_key === key);
    if (!perm || perm.access_level === "NO_ACCESS") return false;
    if (!level) return true;
    if (level === "READ_ONLY") return true;
    return perm.access_level === "FULL";
  };

  return {
    isSuperAdmin,
    role,
    permissions,
    hasPermission,
    isLoading,
    canManageUsers: isCpa || isSuperAdmin,
  };
};
